<ng-select
	appendTo="body"
	id="{{ defaultFilterData?.filterId }}"
	virtualScroll
	[attr.title]="!selectedItem ? getI18nString( false, defaultFilterData?.i18nPath + '.placeholder', true, null) : null"
	[bindLabel]="defaultFilterData?.bindLabel"
	[bindValue]="defaultFilterData?.bindValue"
	[clearAllText]="getI18nString( false, 'shared.listOperations.resetSpecificClear' )"
	[groupBy]="defaultFilterData?.groupBy"
	[items]="filterItems"
	[loading]="filterLoading"
	[placeholder]="getI18nString( false, defaultFilterData?.i18nPath + '.placeholder', true, '')"
	[searchable]="true"
	[typeahead]="filterInput$"
	[(ngModel)]="selectedItem"
	(change)="onChange($event)"
>
	<!-- Options Item -->
	<ng-template
		ng-option-tmp
		let-item="item"
	>
		<ng-container
			[ngTemplateOutlet]="optionItemTpl"
			[ngTemplateOutletContext]="{
				item: item
			}"
		></ng-container>
	</ng-template>

	<!-- Option Group Label -->
	<ng-template
		ng-option-tmp
		ng-optgroup-tmp
		let-item="item"
	>
		<ng-container *ngIf="defaultFilterData?.groupBy">
			{{
			getI18nString(
				false,
				defaultFilterData?.i18nPath + '.' + defaultFilterData?.groupBy + '.' + item[ defaultFilterData?.groupBy ],
				true, item[ defaultFilterData?.groupBy ]
			)
			}}
		</ng-container>
	</ng-template>
</ng-select>

<!-- ######################### TEMPLATES ######################### -->
<!-- Option Item -->
<ng-template
	#optionItemTpl
	let-item="item"
>

	<div
		(mouseenter)="changeTooltipVisibility(tooltip, true, item)"
		(mouseleave)="changeTooltipVisibility(tooltip, false)"
	>
		<span
			#tooltip="ngbTooltip"
			[ngbTooltip]="item[defaultFilterData?.tooltip?.bindKey]"
			[animation]="true"
			[container]="'body'"
			[disableTooltip]="defaultFilterData?.tooltip?.disabled"
			[placement]="defaultFilterData?.tooltip?.placement ?? 'top-start top-end bottom-start bottom-end'"
			[triggers]="null"
		>
			{{ item[ defaultFilterData?.bindLabel ] }}
		</span>
	</div>
</ng-template>
